import React, {PureComponent} from "react";
import Highlighter from "react-highlight-words";
import PageHeaderWrapper from "../../../components/PageHeaderWrapper";
//import GetAllFormFields from '../../../components/_utils/formUtils'
import {FormUtils as GetAllFormFields} from "sz-react-utils";
import {Button, Card, Col, Form, Icon, Input, Checkbox, notification, Popconfirm, Row, Table, Tooltip,} from "antd";
import _ from "lodash";

import {hideLoader, showLoader} from "../../../modules/actions";
import Request from "../../../request";
import {connect} from "react-redux";
import moment from "moment/moment";
import {RightsWrapper} from "../../../components/_utils/utils";
import lodash from 'lodash'

let recordCheckBox = {}

@Form.create()
class Ip extends PureComponent {
    handleSubmit = (e) => {
        const {dispatch, form} = this.props;
        e.preventDefault();
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);

                dispatch(showLoader());

                let x = null;

                x = await Request.addIp(values);

                dispatch(hideLoader());

                if (!x.error) {
                    notification.success({
                        message: x.message,
                    });

                    form.resetFields();
                    this.loadAllowedIps();
                    // this.table.current.reload()
                } else {
                    notification.error({
                        message: "Error Saving",
                        description: x.message,
                    });
                }
            }
        });
    };
    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild});
    };

    delete = async (record) => {
        this.setState({load: true});
        let x = await Request.deleteAllowedIp({ipAddress: record.ipAddress});

        if (x && !x.error) {
            notification.success({
                message: x.message,
            });

            this.setState({load: false});
            this.loadAllowedIps();
        } else {
            notification.error({message: "Try again"});
        }
    };

    loadAllowedIps = async () => {
        let params = {};
        let ipsData = [];

        let {data} = await Request.loadAllowedIps({
            ...params,
            // regExFilters: ['ipAddress']
        });
        _.each(data, (val) => {
            _.each(val.ipAddress, (item) => {
                let abc = {};
                abc.ipAddress = item.ipAddress;
                abc.description = item.description;
                abc.dateTime = item.date;
                abc._id = item._id;
                ipsData.push(abc);
            });
            recordCheckBox = {}
            lodash.each(val.ipAddress, (item) => {
              if (!recordCheckBox[item._id]) {
                recordCheckBox[item._id] = {
                  _id: item._id,
                  ipAddress: item.ipAddress,
                  isChecked: false
                }
              }
            })
        });
        this.setState({ipData: ipsData, recordCheckBox: recordCheckBox});
    };

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
                             setSelectedKeys,
                             selectedKeys,
                             confirm,
                             clearFilters,
                         }) => (
            <div style={{padding: 8}}>
                <Input
                    ref={(node) => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{width: 188, marginBottom: 8, display: "block"}}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{width: 90, marginRight: 8}}
                >
                    Search
                </Button>
                <Button
                    onClick={() => this.handleReset(clearFilters)}
                    size="small"
                    style={{width: 90}}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <Icon type="search" style={{color: filtered ? "#1890ff" : undefined}}/>
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{backgroundColor: "#ffc069", padding: 0}}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
            />
        ),
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({searchText: selectedKeys[0]});
    };

    handleReset = (clearFilters) => {
        clearFilters();
        this.setState({searchText: ""});
    };
    selectRecord = (item, recordId) => {
        let cloneRecordCheckBox = lodash.clone(this.state.recordCheckBox);
        if (cloneRecordCheckBox[recordId] == undefined) {
          cloneRecordCheckBox[recordId] = [];
        }
        cloneRecordCheckBox[recordId].isChecked = !cloneRecordCheckBox[recordId].isChecked
        this.setState({recordCheckBox: cloneRecordCheckBox})
    }
    deleteSelectedIps = async() => {
        let recordArr = lodash.filter(this.state.recordCheckBox, (item) => {
            return (item.isChecked == true?item:false);
        })
        if (recordArr && recordArr.length) {
            this.setState({load: true});
            let ipAddressed = [];
            for (var ipIndex = 0; ipIndex < recordArr.length; ipIndex++) {
                ipAddressed.push(recordArr[ipIndex].ipAddress)
            }
            let x = await Request.deleteMultipleAllowedIp({ipAddress: ipAddressed});

            if (x && !x.error) {
                notification.success({
                    message: x.message,
                });
                this.setState({recordCheckBox: []})
                this.setState({load: false});
                this.loadAllowedIps();
            } else {
                notification.error({message: "Try again"});
            }
        } else {
            notification.error({
                message: 'Please select atleast 1 ip.'
            })
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            ipData: [],
            recordCheckBox:[]
        };
        this.table = React.createRef();
    }

    async componentDidMount() {
        this.loadAllowedIps();
    }

    render() {
        const {
            submitting,
            dispatch,
            form: {getFieldDecorator, getFieldValue, setFieldsValue},
        } = this.props;

        const {ipData} = this.state;

        const submitFormLayout = {
            wrapperCol: {
                xs: {span: 24, offset: 0},
                sm: {span: 10, offset: 7},
                md: {span: 12, offset: 8},
            },
        };

        const columns = [
            {
                title: "Action",
                key: "_id",
                dataindex: "_id",
                width: 50,
                render: (val, record) => (
                    <React.Fragment>
                        <span>
                          <Checkbox
                              checked={recordCheckBox[record._id] ? recordCheckBox[record._id].isChecked : false}
                              onChange={y => {
                                  this.selectRecord(y, record._id)
                              }}>
                          </Checkbox>
                        </span>
                        <RightsWrapper myRight={"IpManagement.delete"}>
                            <Tooltip title={`Delete Ip`}>
                                <Popconfirm
                                    title={`Are you sure to delete this IP `}
                                    onConfirm={() =>
                                        this.delete({
                                            ipAddress: record.ipAddress,
                                        })
                                    }
                                    onCancel={() => {
                                    }}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <Button
                                        shape="circle"
                                        size={"small"}
                                        style={{marginLeft: "5px"}}
                                        icon="delete"
                                    />
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                ),
            },
            {
                title: "IP",
                key: "ipAddress",
                dataIndex: "ipAddress",
                searchTextName: "ipAddress",
                width: 100,
                filterRegex: true,
                ...this.getColumnSearchProps("ipAddress"),
            },

            {
                title: "Description",
                key: "description",
                dataIndex: "description",
                width: 100,
            },

            {
                title: "Date/Time",
                key: "dateTime",
                dataIndex: "dateTime",
                width: 100,
                render: (text, record) => {
                    return (
                        <div>
                            <small>{text ? moment(text).format("lll") : ""}</small>
                        </div>
                    );
                },
            }
        ];

        let inputTypes = {
            fields: [
                {
                    label: "IP Address ",
                    key: "ipAddress",
                    required: true,
                    placeholder: "Enter IP Address",
                    onChange: (ip) => {
                        setFieldsValue({
                            ipAddress: ip.target.value,
                        });
                    },
                },

                {
                    label: "Description",
                    key: "description",
                    required: false,
                    placeholder: "Enter Description",
                },
            ],
        };

        return (
            <PageHeaderWrapper title={"Add Ip"}>
                <Card bordered={true}>
                    <div>
                        <Row>
                            <Col span={12}>
                                <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                                    <GetAllFormFields
                                        inputSchema={inputTypes}
                                        refresh={this.refreshFxn}
                                        loading={this.props.loading}
                                        getFieldDecorator={getFieldDecorator}
                                    />
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        style={{marginBottom: 10, marginLeft: "33%"}}
                                        loading={this.props.loading}
                                    >
                                        SAVE
                                    </Button>
                                </Form>
                            </Col>
                            <Col span={12}>
                                <Button
                                    onClick={() => this.deleteSelectedIps()}>Delete Selected IP
                                </Button>
                                <Table
                                    columns={columns}
                                    ref={this.table}
                                    dataSource={this.state && this.state.ipData}
                                    pagination={false}
                                />
                            </Col>
                        </Row>
                    </div>
                </Card>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Ip);
